import { Directive, OnInit, inject } from '@angular/core';
import { AuthService } from '../services/auth.service';

@Directive({
  selector: '[appAiAssistantWidget]',
  standalone: true,
})
export class AiAssistantWidgetDirective implements OnInit {
  private authService = inject(AuthService);


  ngOnInit(): void {
    if (!this.authService.canSeeAiChat()) {
      return;
    }

    this.loadScript();
  }

  private loadScript(): void {
    const scriptId = 'ai-chat-widget-script';

    if (document.getElementById(scriptId)) {
      return;
    }

    const script = document.createElement('script');

    script.id = scriptId;
    script.src = '/assets/ai-assistant-widget/chat-widget.js';
    script.async = true;

    document.body.appendChild(script);
  }
}
